//export const baseUrl = 'http://10.250.250.108:8084/rest/api'
//export const baseUrl = 'http://teste.nsinova.com.br/allus/api'
//export const baseUrl = 'http://localhost:8080/allus/servico'
export const baseUrl = 'http://prod.nsinova.com.br/allus/api'
//export const baseUrl = `${window.location.protocol}//${window.location.host}/api` 
